<spb-upload-select (files)="receiveDocument($event)"
                   [class]="{hidden: progress() > 0 }"></spb-upload-select>

@if (progress() > 0) {
  <div class="loading-holder">
    <mat-progress-bar [mode]="secondProgressBar$() ? 'buffer' : 'determinate'"
                      [value]="progress()"></mat-progress-bar>
    {{ (total() - remaining()) / 1024 | number: '1.0-0': 'fr' }}
    / {{ total() / 1024 | number: '1.0-0': 'fr' }}
    ( {{ progress()  | number : '1.0-0' }} % )
  </div>
}


@for (document of documentService.createdDocuments(); track document.id) {
  <spb-selected (remove)="deleteFile($event)"
                [document]="document"></spb-selected>
}

@if (documentService.createdDocuments().length > 0 && progress() === 0) {
  <div class="done-holder">
    <p>Klicka på knappen nedan när alla dokument är uppladdade.</p>

    <button (click)="save()" matButton="filled">Skicka till Sparbanken Syd
    </button>
  </div>

}


